import UsersPageView from "./UsersPageView";

function UsersPage() {
  return <UsersPageView />;
}

export default UsersPage;
